import { getWhatsAppCampaign, getWhatsAppCampaigns, getWhatsAppRegistrationDeliveries } from "../api/whatsapp.js";

// The existing API caps each response at 100 records. Load every page before
// handing reports to the shared table so its filters and Excel export agree.
export async function loadWhatsAppReportPages(request, key, signal) {
  const rows = [];
  const seen = new Set();
  let total = null;
  for (let page = 1; total === null || rows.length < total; page += 1) {
    if (signal?.aborted) throw new DOMException("Consulta cancelada", "AbortError");
    const { data } = await request(page);
    if (signal?.aborted) throw new DOMException("Consulta cancelada", "AbortError");
    if (!data || typeof data !== "object") throw new Error("Não foi possível confirmar os registros do relatório. Atualize para tentar novamente.");
    if (data.schema_ready === false) throw new Error("O histórico ficará disponível após a atualização do banco.");
    const batch = data[key];
    const rawTotal = data.pagination?.total ?? data.total;
    const responseTotal = Number(rawTotal);
    if (!Array.isArray(batch) || rawTotal === null || rawTotal === undefined || rawTotal === "" || !Number.isSafeInteger(responseTotal) || responseTotal < 0) {
      throw new Error("Não foi possível confirmar os registros do relatório. Atualize para tentar novamente.");
    }
    if (total === null) total = responseTotal;
    if (responseTotal !== total || rows.length + batch.length > total || (!batch.length && rows.length < total)) {
      throw new Error("O histórico mudou durante a consulta. Atualize para tentar novamente.");
    }
    for (const row of batch) {
      const rawId = row?.[key === "campaigns" ? "campaign_id" : "delivery_id"];
      const id = String(rawId ?? "");
      if (!id || seen.has(id)) throw new Error("O histórico mudou durante a consulta. Atualize para tentar novamente.");
      seen.add(id);
    }
    rows.push(...batch);
  }
  return rows;
}

export const loadWhatsAppCampaignReport = (eventId, signal) => loadWhatsAppReportPages(
  (page) => getWhatsAppCampaigns({ eventId, page, pageSize: 100, signal }), "campaigns", signal,
);

export async function loadWhatsAppMessagesReport({ eventId, eventTimezone, campaigns, signal }) {
  const registration = await loadWhatsAppReportPages(
    (page) => getWhatsAppRegistrationDeliveries({ eventId, timeZone: eventTimezone, page, pageSize: 100, signal }), "deliveries", signal,
  );
  const messages = registration.map((row) => ({ ...row, origin: "Após cadastro", report_date: row.created_at }));
  let nextCampaign = 0;
  let failed = false;
  // Bound concurrent requests when an event has many campaigns.
  await Promise.all(Array.from({ length: Math.min(3, campaigns.length) }, async () => {
    try {
      while (!failed && nextCampaign < campaigns.length) {
        const campaign = campaigns[nextCampaign++];
        const deliveries = await loadWhatsAppReportPages(
          (page) => getWhatsAppCampaign({ eventId, campaignId: campaign.campaign_id, page, pageSize: 100, signal }), "deliveries", signal,
        );
        messages.push(...deliveries.map((row) => ({
          ...row, campaign_id: campaign.campaign_id, campaign_name: campaign.name,
          template_id: campaign.template_id, template_title: campaign.template_title, template_version: campaign.template_version,
          origin: "Campanha", report_date: row.submitted_at || row.updated_at,
        })));
      }
    } catch (error) { failed = true; throw error; }
  }));
  return [...new Map(messages.map((row) => [row.delivery_id, row])).values()];
}
